import { createFileRoute, Link } from "@tanstack/react-router";
import { Button } from "@patient-watch/ui";
import { PageLayout } from "../components/PageLayout";
import { Input } from "@patient-watch/ui";
import { CheckCircle, Users } from "lucide-react";
import { useState } from "react";
import { submitGlucoseContactForm } from "../lib/submitContactForm";
import { useCopy } from "../i18n/locale";

export const Route = createFileRoute("/waitlist")({
    component: WaitlistComponent,
});

function WaitlistComponent() {
    const [succeeded, setSucceeded] = useState(false);
    const [submitting, setSubmitting] = useState(false);
    const copy = useCopy().waitlist;

    if (succeeded) {
        return (
            <PageLayout
                title={copy.successTitle}
                description={copy.successDescription}
                icon={CheckCircle}
                theme="green"
            >
                <Link to="/">
                    <Button variant="default" className="w-full" size="lg">
                        {copy.backHome}
                    </Button>
                </Link>
            </PageLayout>
        );
    }

    async function handleSubmit(e: React.FormEvent<HTMLFormElement>) {
        e.preventDefault();
        setSubmitting(true);
        const form = e.currentTarget;
        const data = new FormData(form);
        try {
            await submitGlucoseContactForm({
                formKey: "waitlist",
                source: "glucose_waitlist",
                fields: {
                    first_name: String(data.get("first_name") ?? ""),
                    last_name: String(data.get("last_name") ?? ""),
                    email: String(data.get("email") ?? ""),
                },
            });
            setSucceeded(true);
        } finally {
            setSubmitting(false);
        }
    }

    return (
        <PageLayout title={copy.title} description={copy.description} icon={Users} theme="blue">
            <form onSubmit={handleSubmit} className="space-y-4">
                <div className="flex md:flex-row flex-col md:gap-x-4">
                    <div className="flex-1 space-y-2">
                        <label htmlFor="first_name" className="font-medium text-sm">
                            {copy.firstName}
                        </label>
                        <Input
                            id="first_name"
                            name="first_name"
                            placeholder="e.g. Tom"
                            className="border-slate-300 rounded-md h-12 text-lg"
                        />
                    </div>
                    <div className="flex-1 space-y-2">
                        <label htmlFor="last_name" className="font-medium text-sm">
                            {copy.lastName}
                        </label>
                        <Input
                            id="last_name"
                            name="last_name"
                            placeholder="e.g. Hanks"
                            className="border-slate-300 rounded-md h-12 text-lg"
                        />
                    </div>
                </div>
                <div className="space-y-2">
                    <label htmlFor="email" className="font-medium text-sm">
                        {copy.email}
                    </label>
                    <Input
                        id="email"
                        type="email"
                        name="email"
                        placeholder="your.email@example.com"
                        className="border-slate-300 rounded-md h-12 text-lg"
                        autoFocus={true}
                        required
                    />
                </div>
                <Button type="submit" className="w-full" size="lg" disabled={submitting}>
                    {submitting ? copy.joining : copy.join}
                </Button>
            </form>
            <Link to="/get-started">
                <Button variant="link" className="w-full" size="lg">
                    {copy.back}
                </Button>
            </Link>
        </PageLayout>
    );
}
